<template>
  <div>
    <!-- modal -->
    <b-modal
      :id="idModal"
      :title="titleModal"
      :ok-variant="variantLabelBtnOk"
      :cancel-variant="variantLabelBtnCancel"
      centered
    >
      <b-card-text>
        {{ message }}
      </b-card-text>

      <template #modal-cancel>
        {{ labelBtnCancel }}

      </template>

      <template #modal-ok>

        <span
          style="padding: 10px 10px"
          @click="handleOk"
        >{{ labelBtnOk }}</span>

      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, VBModal, BCardText,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BModal,
    BCardText,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    titleModal: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    labelBtnCancel: {
      type: String,
      default: 'Cancelar',
    },
    labelBtnOk: {
      type: String,
      default: 'Ok',
    },
    variantLabelBtnOk: {
      type: String,
      default: '',
    },
    variantLabelBtnCancel: {
      type: String,
      default: 'primary',
    },
    idModal: {
      type: String,
      default: 'modal-confirm',
    },
  },
  methods: {
    handleOk() {
      this.$emit('ok')
    },
  },
}
</script>

<style scoped lang="scss">
button[type="button"] {
  background-color: #00cfe8;
}
</style>
